import { Component } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
  selector: 'app-bulk-run-not-Allowed-warning',
  template: `<div class="modal-header" hsDraggable="modal-dialog">
      <h4 class="modal-title">Warning</h4>
      <button
        nf-icon-button
        icon="close"
        class="btn-bare"
        (click)="activeModal.dismiss()"
      >
        Close
      </button>
    </div>
    <div class="modal-body" hsDraggable="modal-dialog">
      <p>
        No dates in the selected range match the defined criteria. Please revise
        your date range or the run frequency settings.
      </p>
    </div>`,
})
export class BulkRunNotAllowedWarningModal {
  constructor(public activeModal: NgbActiveModal) {}
}
